import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import { InstallHint, LiveSwitch, PullToRefresh, TabBar } from './Mobile';

/**
 * The persistent chrome: the fixed header and the scrolling page under it -
 * and on a phone, the tab bar along the bottom (components/Mobile.js).
 *
 * The chrome's own data (which indexers and debrid provider are live) is
 * fetched once here rather than per screen. Each request settles independently,
 * so an unconfigured catalog still leaves a working shell around the search and
 * streaming screens.
 */
const Shell = () => {
  const [indexers, setIndexers] = useState(0);
  const [debrid, setDebrid] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const quiet = () => null;
    axios.get('/api/search/sources').then(({ data }) => setIndexers((data.data || []).length), quiet);
    axios.get('/api/debrid/status').then(({ data }) => setDebrid(data.data), quiet);
  }, []);

  // The Sports/Live TV switch sits under the header on those pages, so on a
  // phone they start a little lower
  const live = pathname === '/sports' || pathname === '/tv';

  return (
    <div className={`app${live ? ' is-live' : ''}`}>
      <Header indexers={indexers} debrid={debrid} />
      <LiveSwitch />
      <PullToRefresh />
      <main className="main">
        <Outlet />
      </main>
      <TabBar />
      <InstallHint />
    </div>
  );
};

export default Shell;
